import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnsModel } from 'src/app/models/column-model';
import { CommonService } from 'src/app/services/Common-function/common.service';


@Component({
  selector: 'ipm-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {
  @Input({ required : true}) columnsData: Array<ColumnsModel> = [];
  @Input({ required :  true}) tableData: Array<any> = [];
  @Input({ required :  false}) currentSection: any = "";
  @Input({ required :  false}) isEventDisabled: boolean = false;
  @Output() OnClickEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() OnClickActionEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(private router: Router, private commonService: CommonService) {}

  ngOnInit(): void {
    if (this.currentSection !== "myorder" && this.currentSection !== "couponList") {
      this.tableData = this.tableData.map(item => ({
        ...item,
        status: item?.payment_transfer_status || item?.status
      }));
    }
  }

  openDetails(data: any) {
    let routerUrl = "/orders";
    if (this.currentSection !== "myorder") {
      routerUrl = "/studio-orders"
    }
    this.router.navigate([routerUrl, data._id]);
  }

  OnClickEventTrigger($event: any) {
    if ($event) {
      this.OnClickEvent.emit($event);
    }
  }

  onActionEvent($event: any) {
    if ($event) {
      this.OnClickActionEvent.emit($event);
    }
  }

  openSupportModel(data: any) {
    this.OnClickActionEvent.emit({action: "supportEvent", tableData: data})
  }

   onClickSupport() {
    this.commonService.openSupport()
  }

  preventDefault(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
  }
}
